import {
  Box,
  makeStyles,
  colors,
  Card,
  CardActionArea,
  CardMedia,
  CardContent,
} from "@material-ui/core";
import React, { ReactNode } from "react";

interface AttachmentProps {
  title: ReactNode;
  subTitle?: ReactNode;
  children?: ReactNode;
}

const useStyles = makeStyles(
  (theme) => ({
    root: {
      paddingLeft: theme.spacing(4),
      paddingRight: theme.spacing(4),

      "& .header": {
        "& span": {
          display: "block",
        },

        "& .title": {
          fontSize: 15,
          fontWeight: theme.typography.fontWeightMedium,
        },

        "& .subTitle": {
          fontSize: 13,
          fontStyle: "italic",
          fontWeight: theme.typography.fontWeightLight,
          color: colors.grey[800],
        },
      },
    },
  }),
  { name: "attachment-styles" }
);

export function Attachment(props: AttachmentProps) {
  const classes = useStyles(props);
  // Props
  const { title, subTitle, children } = props;

  return (
    <Box mt={2} className={classes.root}>
      <Box className="header">
        <Box component="span" className="title">
          {title}
        </Box>
        <Box component="span" className="subTitle">
          {subTitle}
        </Box>
      </Box>
      <Box mt={4} display="flex" alignItems="center" flexWrap="wrap">
        {children}
      </Box>
    </Box>
  );
}

const useAttachmentStyles = makeStyles(
  (theme) => ({
    root: {},

    wrapper: {
      position: "relative",
      cursor: "pointer",

      marginRight: "20px",
      width: (props: AttachmentItemProps) => (props.width ? props.width : 180),
    },

    media: {
      height: 100,
    },

    cardContent: {
      fontSize: 13,
      backgroundColor: "#fafafa",
      borderTop: "1px solid #e8e8e8",
      padding: "10px 10px",

      whiteSpace: "nowrap",
      overflow: "hidden",
      textOverflow: "ellipsis",
    },
  }),
  { name: "attachment-item-styles" }
);

interface AttachmentItemProps {
  children: ReactNode;
  src: string;
  height?: string | number;
  width?: string | number;
}

export function AttachmentItem(props: AttachmentItemProps) {
  const classes = useAttachmentStyles(props);
  // Props
  const { src, children } = props;

  const handleClick = (event: any) => {
    document.location.href = src;
  };

  // Events

  return (
    <Box className={classes.root}>
      <a href={src} target="_blank">
        <Card className={classes.wrapper}>
          <CardActionArea>
            <CardMedia className={classes.media} image={src} title="" />
            <CardContent className={classes.cardContent}>
              {children}
            </CardContent>
          </CardActionArea>
        </Card>
      </a>
    </Box>
  );
}
